<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label
      slot="label"
      v-if="!!inputLabel"
      :for="inputName">

      {{ inputLabel }}
    </label>

    <div
      slot="input"
      slot-scope="{ params }">

      <input
        type="number"
        :disabled="dissabled"
        :placeholder="getPlaceholderLabel"
        :class="`${getInnerStyle} ${errorStyle(params)}`"
        :id="identification"
        :name="inputName"
        v-model="value"
        @keyup="sendUpdate()" />

    </div>
    <span
      v-if="getFootnote"
      slot="footnote">

      {{ getFootnote }}
    </span>

    <q-icon
      v-if="!!iconRight"
      slot="icon-right"
      :allowSelfUpdate="false"
      width="15px"
      :name="iconRight" />

  </input-base>
</template>

<script>
import QIcon from '@/components/standard/display/QIcon'
import InputBase from '@/components/standard/input/InputBase'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import inputValidator from '@/mixins/standard/input/inputValidator'
import '@/assets/styles/standardInputs.css'

export default {
  data () {
    return {
      value: this.inputValue
    }
  },

  computed: {
    /**
     * Gives input's value
     * @returns {Number}
     */
    getInputValue () {
      return parseFloat(this.value)
    }
  },

  watch: {
    inputValue: function () {
      this.value = this.inputValue
    }
  },
  components: {
    'q-icon': QIcon,
    'input-base': InputBase
  },
  mixins: [
    inputValidator,
    stylers
  ],
  props: {
    inputValue: {
      type: Number,
      required: false,
      default: null
    }
  },
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
  -webkit-appearance: none;
  margin: 0;
}

input {
  width: 100%;
  outline: 0;
  padding: 11px 18px;
  background-color: transparent;
}
.tighter {
  padding: 3px 7px;
  font-size: 10px;
  color: #1E1E1E;
  width: auto;
}
.p-holder {
  position: absolute;
  margin-top: 15px;
  font-size: 14px;
  margin-left: 17px;
  transition: margin .3s, font-size .3s;
}
.above {
  margin-top: -15px;
  margin-left: 0px;
  font-size: 10px;
}

.small {
  padding-top: 1px!important;
  padding-bottom: 1px!important;
  height: 27px!important;
}
.smaller {
  padding-top: 4px!important;
  padding-bottom: 4px!important;
  height: 32px!important;
}

</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputNumber.vue?d31a608c